import { useClient } from './useClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ServiceConfigRequest } from '@hud/rules-dtos/api-rules.dtos';
import { RULE_ID } from './useRule';

export default function useUpdateServiceConfigMutation(
  ruleId: string,
  serviceConfigId: string | null,
) {
  const { client } = useClient('detection');
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: ServiceConfigRequest) =>
      client.put(
        `/rules/${ruleId}/service-configs/${serviceConfigId}`,
        request,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [RULE_ID, ruleId] });
    },
  });
}
